import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from "ngx-toastr";
import { from, Observable } from "rxjs";
import { ProductsMenu } from "../entities/productMenu";
import { HttpService } from "./http-service";
import { Configuracoes } from "../entities/configuracoes";
import { Injectable } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
@Injectable({
  providedIn: "root",
})
export class CatalogService extends HttpService {
  constructor(
    http: HttpClient,
    router: Router,
    toastService: ToastrService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    super(http, router, toastService, platformId);
  }

  getMenu(): Observable<ProductsMenu[]> {
    return from(this.http.get(Configuracoes.API +'principal/menu', this.getHttpOptions()) as unknown as Promise<ProductsMenu[]>);
  }
  
  getCatalogoPdf(itens, callback, callbackErro) {
    this.postPdf(`print/formulario`, itens, callback, callbackErro);
  }


    getHttpOptions() {
      let headersObj: any = {
        'Content-Type': 'application/json',
        Branch: Configuracoes.API_BRANCH,
        'Access-Control-Allow-Origin': '*'
      };
    
      if (this.hasToken()) {
        headersObj = {
          ...headersObj,
          Authorization: 'Bearer ' + this.getToken()
        };
      }
    
      const headers = new HttpHeaders(headersObj);
      return { headers };
    }
}
